import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "@/lib/api";
import { ArrowLeft, FlaskConical, ExternalLink, Loader2 } from "lucide-react";

export default function LabInfoPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { API.get("/content/lab-info").then(r => setItems(r.data || [])).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <div className="space-y-5" data-testid="lab-info-page">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="p-1.5 rounded-lg hover:bg-gray-100"><ArrowLeft className="w-5 h-5" /></button>
        <div><h1 className="text-xl font-bold text-gray-900">Lab Info</h1><p className="text-xs text-gray-500">Latest lab information and updates</p></div>
      </div>
      {loading ? <div className="text-center py-12"><Loader2 className="w-6 h-6 animate-spin text-[#008A99] mx-auto" /></div> :
        items.length === 0 ? <p className="text-center text-gray-400 py-12 text-sm">No lab info available yet</p> :
        <div className="space-y-3">
          {items.map(item => (
            <div key={item.id} className="bg-white rounded-xl p-4 border" data-testid="lab-info-item">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#E0F4F5] rounded-lg flex items-center justify-center flex-shrink-0"><FlaskConical className="w-5 h-5 text-[#008A99]" /></div>
                <div className="flex-1">
                  <p className="font-semibold text-gray-900">{item.title}</p>
                  {item.content && <p className="text-sm text-gray-500 mt-1">{item.content}</p>}
                  {item.link && <a href={item.link} target="_blank" rel="noopener noreferrer" className="text-xs text-[#008A99] font-medium flex items-center gap-1 mt-2"><ExternalLink className="w-3 h-3" /> Read More</a>}
                </div>
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  );
}
